import React, { useState, useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import EventItem from './EventItem'
import { getPaginatedEvents } from '../constants'
import Paginator from 'components/Shared/Paginator'
import { useEditEventSeriesContext } from '../EditEventSeriesProvider'


export default function EventsList(props) {
  const { events = [], isIncluded = true, emptyMessage = '' } = props
  const { isSelecting } = useEditEventSeriesContext()
  
  const [page, setPage] = useState(1)

  const paginatedEvents = useMemo(() => {
    return getPaginatedEvents(events, page)
  }, [events, page])

  const handlePageChange = (newPage) => {
    setPage(newPage)
  }

  useEffect(() => {
    setPage(1)
  }, [events.length])

  return (
    <>
      <ul className='event-list'>
        {paginatedEvents.data.map((event) => (
          <EventItem key={event.id} event={event} isIncluded={isIncluded} isSelecting={isSelecting} />
        ))}
      </ul>
      
      {events.length === 0 && emptyMessage && (
        <div className='event-list_empty-message-wrapper'>
          <p className='event-list_empty-message'>{emptyMessage}</p>
        </div>
      )}

      {events.length > 10 && (
        <Paginator
          page={page}
          totalPages={paginatedEvents.totalPages}
          pageSize={10}
          totalItems={paginatedEvents.total}
          onPageClicked={handlePageChange}
          hideWhenSinglePage
          classNames='mt-3'
        />
      )}
    </>
  )
}

EventsList.propTypes = {
  events: PropTypes.array.isRequired,
  isIncluded: PropTypes.bool.isRequired,
  emptyMessage: PropTypes.string,
}